import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  postName: "",
  email: "",
  subject: "",
  message: "",
}

const postsSlice = createSlice({
  name: 'posts',
  initialState,
  reducers: {
    postPushed(state, action) {
      return {
        ...state,
        postName: action.payload.postName,
        email: action.payload.email,
        subject: action.payload.subject,
        message: action.payload.message,
      }
    }
  }
})

export const { postPushed } = postsSlice.actions

export default postsSlice.reducer